module.exports = __webpack_public_path__ + "img/dna3_600.b8a4312e.jpg";